export enum ServiceTypeSearchEnum {
    Generic = 1,
    AfterHours = 2,
    Medibank = 3,
}

export interface UserBookingDetails {
    userId: number;
    bpUserId: number;
    displayName: string;
}

export interface FirstAvailableModel {
    user: UserBookingDetails;
    firstAvailable: FirstAvailable;
}

export interface FirstAvailable extends AutomedDoctorAvailabilityTimeModel {
    date: string;
}

export type TimeSlots = Record<string, TimeSlot[]>;

export type TimeSlot = {
    time: string;
    duration: string;
};

export interface AutomedDoctorDateModel {
    first_available: FirstAvailable;
    calendar: string[];
}

export type AppointmentType = {
    site: string;
    serviceTypeId: number;
    serviceTypeName: string;
    appointmentTypeId: string;
    appointmentName: string;
    appointmentBPName: string;
    standardDurationInMins: string;
    isF2F: boolean;
    startTime: string;
    endTime: string;
    weekdaysOnly: boolean;
    weekendOnly: boolean;
    nurseRequired?: boolean;
    isDefaultAppt: boolean;
    cancellationPeriodInPriorHrs: string;
    questionRequired: boolean;
    continueOrNo: boolean;
    /** @description Prescreening Question / Information */
    apptQuestionInBase64: string;
    /** @description Instruction to Patient if unable to Proceed */
    apptInstructionsInHTML: string;
    newPatient: boolean;
    prePaymentRequired: boolean;
    prePaymentFees: string;
    prePaymentMessageInHTML: string;
    prePaymentConfirmMessage: string;
    postPaymentRequired: boolean;
    postBillingType: string;
    postBillingFees: string;
    postBillingMessageInHTML: string;
    postBillingConfirmMessageInHTML: string;
    consentEnabled: boolean;
    consentId: string;
    lowAgeMin: string | null;
    lowAgeMax: string | null;
    upperAgeMin: string | null;
    upperAgeMax: string | null;
    lastF2FVisitInMonths: string;
    displayOnlyMessage: string;
    displayOnly: '0' | '1';
    requireMedicareCard: boolean;
    requireDVA: boolean;
    requireHCC: boolean;
    requirePrivateHCC: boolean;
    requireAOB: boolean;
    aobServiceCategoryName: string;
};

export interface SiteBookingAvailabilityModel {
    user: UserBookingDetails;
    timeSlots: Record<string, AutomedClinicAvailabilityTimeModel[]>;
}
export interface AutomedClinicAvailabilityTimeModel {
    t: string;
    d: string;
    ab?: string;
    r1?: string;
    r2?: string;
    r3?: string;
    r4?: string;
}

export interface AutomedDoctorAvailablilityModel {
    timeslot: Record<string, AutomedDoctorAvailabilityTimeModel[]>;
    first_available?: FirstAvailable;
}

export interface AutomedDoctorAvailabilityTimeModel {
    time: string;
    duration: string;
    ab?: string;
    r1?: string;
    r2?: string;
    r3?: string;
    r4?: string;
}
